/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	SET_TRANSACTION_TYPES(state, transactionTypes) {
		state.transactionTypes = transactionTypes
		state.loading = false
	},
	FETCH_TRANSACTION_TYPES(state) {
		state.loading = true
	}
}
